import React from 'react';

import ClubAffiliationTypeContextProvider from '@usas/ui-web/state/clubAffiliationType/ClubAffiliationTypeContextProvider'
import PoolDimensionsContextProvider from '@usas/ui-web/state/poolDimensions/PoolDimensionsContextProvider';
import CourseContextProvider from '@usas/ui-web/state/course/CourseContextProvider';

const AppStateContextProviders = ({ children }) => {
  return (
    <ClubAffiliationTypeContextProvider>
      <PoolDimensionsContextProvider>
        <CourseContextProvider>
          {children}
        </CourseContextProvider>
      </PoolDimensionsContextProvider>
    </ClubAffiliationTypeContextProvider>
  );
};
export default AppStateContextProviders;